import { useMutation } from '@tanstack/react-query';
import type { AccountTrialPostRequest, AccountTrialPostResponse } from '../types/AccountTrial';

export default function usePostAccountTrial() {
  return useMutation({
    mutationFn: async (params: AccountTrialPostRequest): Promise<AccountTrialPostResponse> => {
      const response = await fetch('/account/api/signup', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // 422はバリデーションエラー（free_email等）のレスポンスを含むため正常にパース
      if (!response.ok && response.status !== 422) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return response.json();
    },
  });
}
